export interface Author {
  name: string;
  email: string;
  image: string;
  role: { en: string; sv: string };
  bio: { en: string; sv: string };
  social?: { linkedin?: string };
}

export type AuthorKey = keyof typeof authors;

/* `satisfies` rather than an annotation: an annotation widens `keyof` to
   `string`, so a typo in blog frontmatter (`author: andres`) type-checked
   fine and failed only at render time. */
export const authors = {
  andreas: {
    name: 'Andreas Lundmark',
    email: 'andreas@berget.ai',
    image: '/team/andreas.png',
    role: {
      en: 'Co-founder & CEO',
      sv: 'Medgrundare & VD',
    },
    bio: {
      en: 'Andreas was an integral part of building the AI capabilities and offering at Boston Consulting Group (BCG Gamma) where he led the Nordic team and was globally responsible for the "AI at Scale" topic, and led multiple large scale data and AI transformations at leading global brands',
      sv: 'Ledde uppbyggnaden av AI-erbjudandet på Boston Consulting Group (BCG Gamma) där han ledde det nordiska teamet och var globalt ansvarig för "AI at Scale"-området, och ledde flera storskaliga data- och AI-transformationer på ledande globala företag',
    },
    social: {
      linkedin: 'andreaslundmark',
    },
  },
  christian: {
    name: 'Christian Landgren',
    email: 'christian@berget.ai',
    image: '/team/christian.png',
    role: {
      en: 'Co-founder & CPTO',
      sv: 'Medgrundare & CPTO',
    },
    bio: {
      en: '30 years of experience helping organisations with digitalisation and AI, passionate about AI and software development, deeply engaged in open source and open innovations, trusted advisor to government and public sector, challenger and technology optimist',
      sv: '30 års erfarenhet av att hjälpa organisationer med digitalisering och AI, passionerad för AI och mjukvaruutveckling, djupt engagerad i open source och öppen innovation, betrodd rådgivare till regering och offentlig sektor, utmanare och teknikoptimist',
    },
    social: {
      linkedin: 'christianlandgren',
    },
  },
  'christian-ciso': {
    name: 'Christian Landgren',
    email: 'christian@berget.ai',
    image: '/team/christian.png',
    role: {
      en: 'Co-founder & CISO',
      sv: 'Medgrundare & CISO',
    },
    bio: {
      en: '30 years of experience helping organisations with digitalisation and AI, passionate about AI and software development, deeply engaged in open source and open innovations, trusted advisor to government and public sector, challenger and technology optimist',
      sv: '30 års erfarenhet av att hjälpa organisationer med digitalisering och AI, passionerad för AI och mjukvaruutveckling, djupt engagerad i open source och öppen innovation, betrodd rådgivare till regering och offentlig sektor, utmanare och teknikoptimist',
    },
    social: {
      linkedin: 'christianlandgren',
    },
  },
  marcus: {
    name: 'Marcus Olsson',
    email: 'marcus@berget.ai',
    image: '/team/marcus.jpg',
    role: {
      en: 'Developer Relations',
      sv: 'Developer Relations',
    },
    bio: {
      en: '15 years of experience in building cloud-native data applications, designing developer experiences, and educating developer audiences.',
      sv: '15 års erfarenhet av att bygga molnbaserade dataapplikationer, designa utvecklarupplevelser och utbilda utvecklarpubliker.',
    },
    social: {
      linkedin: 'marcusolsson1',
    },
  },
  'berget-team': {
    name: 'Berget Team',
    email: 'hello@berget.ai',
    image: '',
    role: {
      en: '',
      sv: '',
    },
    bio: {
      en: '',
      sv: '',
    },
  },
  johan: {
    name: 'Johan Lahti',
    email: '',
    image: '/team/johan-profil.jpg',
    role: {
      en: 'Datacenter Networking',
      sv: 'Nätverk och Datacenter',
    },
    bio: {
      en: 'A leading Data Center network designer and builder who has helped leading enterprises and scale-ups build global multi-site datacenter deployments',
      sv: 'En ledande datacenternätverksdesigner som har hjälpt ledande företag och scale-ups att bygga globala multi-site serverplattformar',
    },
  },
  sara: {
    name: 'Sara Alsén',
    email: '',
    image: '/team/sara_bw.jpg',
    role: {
      en: 'Communication & Marketing',
      sv: 'Communication & Marketing',
    },
    bio: {
      en: 'Sara has over 25 years of experience of building brands with purpose through impactful communication - for start-ups and multinationals.',
      sv: 'Sara har över 25 års erfarenhet av att bygga syftesdrivna varumärken genom kraftfull kommunikation – för både start-ups och multinationella företag.',
    },
  },
  oscar: {
    name: 'Oscar Virot',
    email: '',
    image: '/team/oscar.jpg',
    role: {
      en: 'Tech & Infra',
      sv: 'Tech & Infra',
    },
    bio: {
      en: 'Tech and support for everything related to networks and servers. 20+ years of experience in sysadmin, network, and server operations',
      sv: 'Tech och support på allt som heter nätverk och servrar. 20+ års erfarenhet från sysadmin, nätverks- och serverdrift.',
    },
  },
  erik: {
    name: 'Erik Sundberg',
    email: '',
    image: '/team/erik.jpg',
    role: {
      en: 'GTM Lead',
      sv: 'GTM Lead',
    },
    bio: {
      en: "Leads Berget AI's go-to-market work with enterprise customers and partner channels.",
      sv: 'Leder Berget AIs go-to-market-arbete med enterprisekunder och partnerkanaler.',
    },
  },
  gabriel: {
    name: 'Gabriel Paues',
    email: '',
    image: '/team/gabriel.jpg',
    role: {
      en: 'Site Reliability Engineer',
      sv: 'Site Reliability Engineer',
    },
    bio: {
      en: "Works with SRE and operationalising Berget AI's quality system, bringing decades of experience in private cloud, networking and beyond.",
      sv: 'Arbetar med SRE och att operationalisera Berget AIs kvalitetssystem, och har decenniers erfarenhet av privat moln, nätverk och mer därtill.',
    },
  },
  jakob: {
    name: 'Jakob Karlstrand',
    email: '',
    image: '/team/jakob.jpg',
    role: {
      en: 'Product & Engineering',
      sv: 'Produkt och teknik',
    },
    bio: {
      en: "Full-stack engineer in the product team, accelerating Berget AI's product roadmap and customer projects.",
      sv: 'Fullstack-utvecklare i produktteamet som accelererar Berget AIs produktroadmap och kundprojekt.',
    },
  },
  hugo: {
    name: 'Hugo Björk',
    email: '',
    image: '/team/hugo.jpg',
    role: {
      en: 'Product & Engineering',
      sv: 'Produkt och teknik',
    },
    bio: {
      en: 'First employee at Berget AI, working across product development and operations. Holds an M.Sc. in Machine Learning with a background in consulting, data science, and co-founding a SaaS startup.',
      sv: 'Första anställd på Berget AI och arbetar brett med produktutveckling och drift. Har en masterexamen i maskininlärning med bakgrund inom konsulting, data science och som medgrundare till ett SaaS-bolag.',
    },
  },
  eve: {
    name: 'Eve Chen',
    email: 'eve@berget.ai',
    image: '/team/eve.jpg',
    role: {
      en: 'Infra & Platform Engineer',
      sv: 'Infrastruktur- och plattformsingenjör',
    },
    bio: {
      en: "Leads the development of Berget AI's Kubernetes platform and offerings. Enthusiastic about agent productivity and better workflows for AI-assisted engineering.",
      sv: 'Leder utvecklingen av Berget AIs Kubernetes-plattform och erbjudanden. Entusiastisk kring agentproduktivitet och bättre arbetsflöden för AI-assisterad ingenjörskonst.',
    },
  },
};

export function getAuthor(key: AuthorKey): Author | undefined {
  return authors[key];
}
